export enum GridSpacing {
  None = "none",
  XS = "xs",
  SM = "sm",
  MD = "md",
  LG = "lg",
  XL = "xl",
}

export enum GridDensity {
  SINGLE_ELEMENT = "single-element",
  REGULAR = "regular",
  LARGE = "large",
  COMPACT = "compact",
}

export enum GridColorSchemes {
  Primary = "primary",
  LightDarkTitle = "light-dark-title",
  NeutralDarkTitle = "neutral-dark-title",
  NeutralPrimaryTitle = "neutral-primary-title",
  LightPrimaryTitle = "light-primary-title",
  Dark = "dark",
  Glass = "glass",
  Wood = "wood",
  Stone = "stone",
  Materia = "materia",
  Metal = "metal",
}

export enum GridTitleColors {
  PRIMARY = "primary",
  NEUTRAL = "neutral",
  TEXT_LIGHT = "text-light",
}

export enum GridTitleSizes {
  MD = "regular",
  SM = "small",
}

export enum GridTitleAlignments {
  LEFT = "left",
  CENTER = "center",
}
